import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import RackPhotoUpload from '../../components/RackPhotoUpload';
import { rackDeviceGetByIdService } from 'services/rackdevice';

const RackDeviceUpload = () => {
  const { id } = useParams();
  const [device, setDevice] = useState(null);

  useEffect(() => {
    const loadDeviceData = () => {
      rackDeviceGetByIdService(id)
        .then((response) => {
          setDevice(response.data.items);
        })
        .catch((error) => {
          console.error('Failed to load rack device details:', error);
        });
    };

    loadDeviceData();
  }, [id]);

  return (
    <div className="rack-device-upload">
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Networking Dashboard', path: '/network-dashboard' },
          { label: 'Rack Devices', path: '/rackdevice' },
          { label: 'Upload Photos', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={`Rack Device Photos - ${device?.equipment_name || 'Loading...'}`}
        subTitle=""
      >
        <RackPhotoUpload moduleType="rackDevice" moduleId={id} />
      </PageHeader>
    </div>
  );
};

export default RackDeviceUpload;
